import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, AlertCircle, Play, Loader2 } from "lucide-react";
import { userAnswersAPI } from "../api";
import { useLang } from "../context/LangContext";

const MistakesPage: React.FC = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const [mistakes, setMistakes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMistakes = async () => {
      try {
        setLoading(true);
        const res = await userAnswersAPI.getMistakes(lang);

        // Backenddan kelgan "answer" obyektlari ichidan "question"ni ajratib olamiz
        // m.question - sening eski kodingdagi format
        const formatted = res.data.map((m: any) => m.question || m);
        setMistakes(formatted);
      } catch (err) {
        console.error("Xatolarni yuklashda xato:", err);
        setMistakes([]);
      } finally {
        setLoading(false);
      }
    };
    fetchMistakes();
  }, [lang]);

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)" }}>
      {/* Fixed Header */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          background: "rgba(10,14,26,.95)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid var(--border)",
          height: 52,
        }}>
        <div
          style={{
            maxWidth: 520,
            margin: "0 auto",
            padding: "0 16px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() => navigate("/dashboard")}
              style={{
                background: "transparent",
                border: "none",
                color: "var(--muted)",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                fontWeight: 600,
              }}>
              <ArrowLeft size={16} /> Orqaga
            </button>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>
              Mening xatolarim
            </span>
          </div>

          {mistakes.length > 0 && (
            <button
              onClick={() => navigate("/quiz/mistakes")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "6px 14px",
                borderRadius: 10,
                background: "#EF4444",
                border: "none",
                color: "#fff",
                fontSize: 12,
                fontWeight: 800,
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(239, 68, 68, 0.2)",
              }}>
              <Play size={12} fill="currentColor" /> Boshlash
            </button>
          )}
        </div>
      </div>

      <div
        style={{ maxWidth: 520, margin: "0 auto", padding: "68px 16px 32px" }}>
        {loading ?
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: 100,
            }}>
            <Loader2 className="animate-spin text-red-500" size={32} />
          </div>
        : mistakes.length === 0 ?
          <div
            className="fade-up"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 80,
              textAlign: "center",
              gap: 20,
            }}>
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: 24,
                background: "rgba(34, 197, 94, 0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <AlertCircle size={32} style={{ color: "#22C55E" }} />
            </div>
            <div>
              <p
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: 18,
                  marginBottom: 8,
                }}>
                Hamma xatolar tuzatildi!
              </p>
              <p
                style={{
                  color: "var(--muted)",
                  fontSize: 14,
                  lineHeight: 1.5,
                  maxWidth: 280,
                }}>
                Sizda hozircha xato javob berilgan savollar mavjud emas. Juda
                yaxshi!
              </p>
            </div>
            <button
              onClick={() => navigate("/dashboard")}
              style={{
                marginTop: 10,
                padding: "12px 24px",
                borderRadius: 12,
                background: "var(--card)",
                border: "1px solid var(--border)",
                color: "#fff",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
              }}>
              Asosiy sahifaga qaytish
            </button>
          </div>
        : <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
                padding: "0 4px",
              }}>
              <p
                style={{
                  color: "var(--muted)",
                  fontSize: 12,
                  fontWeight: 600,
                }}>
                JAMI:{" "}
                <span style={{ color: "#EF4444", fontWeight: 800 }}>
                  {mistakes.length} TA SAVOL
                </span>
              </p>
              <span
                style={{ fontSize: 11, color: "var(--muted)", opacity: 0.6 }}>
                Xatolar ustida ishlash uchun "Boshlash"ni bosing
              </span>
            </div>

            {mistakes.map((q, i) => (
              <div
                key={q.id || i}
                className="fade-up"
                style={{
                  animationDelay: `${i * 30}ms`,
                  background: "var(--card)",
                  border: "1px solid rgba(239, 68, 68, 0.15)",
                  borderRadius: 16,
                  padding: "16px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}>
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "flex-start",
                  }}>
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 8,
                      background: "rgba(239, 68, 68, 0.1)",
                      color: "#EF4444",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      fontWeight: 800,
                      flexShrink: 0,
                      marginTop: 2,
                    }}>
                    {i + 1}
                  </div>
                  <p
                    style={{
                      color: "#E2E8F0",
                      fontSize: 14,
                      lineHeight: 1.5,
                      fontWeight: 500,
                    }}>
                    {q.text || q.question}
                  </p>
                </div>

                {q.photo_url && (
                  <img
                    src={q.photo_url}
                    alt=""
                    style={{
                      width: "100%",
                      borderRadius: 12,
                      marginTop: 12,
                      border: "1px solid var(--border)",
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  );
};

export default MistakesPage;
